// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__37prr","options":"AnswerScale_options__3Xz4r","selected":"AnswerScale_selected__1EUbD"};